<svelte:options runes={true} />

<script lang="ts">
	type Provider = "synthesia" | "kaltura";

	interface PlayerProps {
		src: string;
		autoplay?: boolean;
		style?: string;
		provider: Provider;
	}

	let { src, autoplay = false, style, provider }: PlayerProps = $props();

	let videoUrl = $state("");

	$effect(() => {
		if (!src || !provider) {
			videoUrl = "";
		} else if (provider === "kaltura") {
			if (src.includes("://")) {
				videoUrl = src;
			} else {
				const [partnerId, uiconfId, entryId] = src.split("|");
				videoUrl = partnerId && uiconfId && entryId ? `https://cdnapisec.kaltura.com/p/${partnerId}/embedPlaykitJs/uiconf_id/${uiconfId}?iframeembed=true&entry_id=${entryId}&config[playback]=${encodeURIComponent(JSON.stringify({ autoplay }))}` : "";
			}
		} else if (provider === "synthesia") {
			videoUrl = `https://share.synthesia.io/embeds/videos/${src}?autoplay=${autoplay ? 1 : 0}`;
		}
	});
</script>

<iframe {style} src={videoUrl} class="aspect-video w-full rounded-lg" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen loading="lazy" title={`${provider} video player`}></iframe>
